<template>
    <div>
        <menu-bar></menu-bar>

        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li><a href="#/">INICIAL</a></li>
                    <li class="active">BUSCAR CLIENTE POR IPV6</li>
                </ol>

                <div class="row">
                    <div class="col-md-12">

                        <form class="form-horizontal">

                            <div class="panel panel-info">
                                <div class="panel-heading">BUSCA DE CLIENTE POR IPV6</div>
                                <div class="panel-body">

                                    <div class="form-group">
                                        <div class="col-sm-6">
                                            <label for="link_total" class="control-label">IPV6</label>
                                            <input id="link_total" v-model="ipv6" class="form-control"><br/>
                                            <button :disabled="! ipv6 || ! ano || ! mes" @click.stop.prevent="buscar()" class="btn btn-success">
                                                BUSCAR CLIENTE
                                            </button>
                                        </div>
                                        <div class="col-sm-2">
                                            <label for="link_total" class="control-label">MÊS</label>
                                            <combo-meses v-model="mes" class="form-control"/><br/>
                                        </div>
                                        <div class="col-sm-2">
                                            <label for="link_total" class="control-label">ANO</label>
                                            <combo-anos v-model="ano" class="form-control"/><br/>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </form>

                        <table v-if="lista" id="mytable" class="table table-bordred table-striped">

                            <thead>

                                <tr>
                                    <th>CLIENTE</th>
                                    <th style="text-align: center;">DATA LOGIN</th>
                                    <th style="text-align: center;">PREFIX IPV6</th>
                                    <th style="text-align: center;width: 240px">INTERFACE</th>
                                </tr>

                            </thead>

                            <tbody>

                                <tr v-for="r in lista" v-bind:key="r._id">
                                    <td v-if="r.contrato && r.contrato.cliente && r.contrato.cliente.nome">{{ r.contrato.cliente.nome }}</td>
                                    <td v-else>CLIENTE INDISPONÍVEL</td>
                                    <td class="text-center">{{ r.created_at | date("DD/MM/YYYY HH:mm:ss") }}</td>
                                    <td class="text-center">{{ r.ip }}</td>
                                    <td class="text-center">{{ r.interface }}</td>
                                </tr>

                            </tbody>

                        </table>

                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Ipv6 } from "../../class/index";
import ComboMeses from "../../components/combo/meses";
import ComboAnos from "../../components/combo/anos";
import { date } from "../../filters";
export default {
    name: "BuscaClienteIpv6",
    components: {
        ComboMeses,
        ComboAnos
    },
    filters: {
        date
    },
    data() {
        return {
            ipv6: null,
            mes: null,
            ano: null,
            lista: null
        };
    },
    methods: {
        async buscar() {
            this.lista = await Ipv6.buscar(this.ipv6, this.mes, this.ano);
        }
    }
};
</script>

<style scoped>
</style>
